const dashboardSelectedMissionsApprovalsReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_DASHBOARD_SELECTED_MISSIONS_APPROVALS':
      return [...action.payload];
    default:
      return state;
  }
};

export default dashboardSelectedMissionsApprovalsReducer;
